import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ReactNode } from "react";

/**
 * WhiteLine theme provider.
 *
 * Wraps `next-themes` with brand defaults so the rest of the app can stay
 * agnostic of the underlying library. All colour tokens live in
 * `src/shared/styles/theme.css` and are swapped by toggling the `.dark`
 * / `.light` class on <html>.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey="whiteline-theme"
      themes={["light", "dark"]}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
